export default __webpack_public_path__ + "static/media/s3.85f9a68d.jpg";